import { Box, LinearProgress } from '@mui/material'
import './styles.scss'

export const LoadingComponent = ({label}:{label:string}) => {
    return (
        <>
            <Box className="modal_update_planning_task_loading_background" />
            <Box className="modal_update_planning_task_loading">
                {/* <CircularProgress size="8rem" /> */}
                <LinearProgress />
                {label}
            </Box>
        </>
    )
}